module.exports = __webpack_public_path__ + "static/media/project_default_banner.e67acb74.jpeg";